<div
  class="filter-item"
  [matMenuTriggerFor]="statusFilter"
  #trigger="matMenuTrigger"
  [ngClass]="{
    active: checkedCount > 0 || isOpen || !isVerified,
    mobile: mobile
  }"
  (menuOpened)="isOpen = true"
  (menuClosed)="isOpen = false"
>
  <span>
    Status
    <span *ngIf="checkedCount > 0 || !isVerified"
      >({{ checkedCount + (!isVerified ? 1 : 0) }})</span
    >
  </span>
  <app-shared-icon name="chevron-down-2"></app-shared-icon>
</div>

<mat-menu #statusFilter="matMenu" xPosition="after" class="filters-mat-menu">
  <div
    class="filter-dropdown"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <ul>
      <li class="toggler">
        <mat-checkbox
          labelPosition="before"
          color="primary"
          [checked]="allSelected"
          (change)="toggleAllSelection()"
          >{{ allSelected ? 'Deselect' : 'Select' }} all</mat-checkbox
        >
      </li>
      <li *ngFor="let status of statuses; trackBy: trackByStatus">
        <mat-checkbox
          labelPosition="before"
          color="primary"
          [(ngModel)]="checkedStatuses[status]"
          (ngModelChange)="onChangeStatuses()"
          [value]="status"
        >
          {{
            (status === 'OPEN' ? 'ACTIVE' : status)
              | stringTransform: 'capitalizeFirstLetter'
          }}
        </mat-checkbox>
      </li>
      <li>
        <mat-checkbox
          color="primary"
          labelPosition="before"
          [checked]="!isVerified"
          (change)="toggleIsVerified()"
        >
          3rd Party Listings
        </mat-checkbox>
      </li>
    </ul>

    <app-filter-v2-buttons
      *ngIf="!mobile"
      (resetAction)="resetStatuses()"
      (applyAction)="closeMenu()"
    ></app-filter-v2-buttons>
  </div>
</mat-menu>
